/**
 * Translation resolver for the Supermail plugin.
 *
 * The AMC host renderer resolves user-facing strings through i18next (`rendererT`); this webview
 * plugin ships English-only for now, but this is a REAL locale-aware resolver — NOT a key-ignoring
 * passthrough. The resolver logic (host UI language, `{{name}}` interpolation, CLDR
 * `Intl.PluralRules` plural selection, the `activeLocale` Intl seam) lives ONCE in the shared
 * vendor-sdk factory; this island supplies only its own `CATALOGS`. No non-English Supermail
 * catalog is wired yet, so it still returns English today — but the swap point is real: drop a
 * locale into `CATALOGS` and every keyed string localizes with no call-site change (i18n audit).
 * New user-facing copy routes through THIS `rendererT(key, english)` instead of a bare literal — the
 * plugin-hardcoded-string ratchet fails the build on a NEW raw string, and a wrapped string is
 * expression-valued so it is not charged. Mirrors the decks resolver. See
 * .claude/memory/contracts/plugin-standards-enforcement-contract.md.
 */

import { createPluginI18n } from '../../../../vendor-sdk/i18n';

// locale (e.g. 'es') -> { translationKey -> translated string }. Empty until a non-English
// Supermail catalog is authored; add one here to light up that language.
const CATALOGS: Record<string, Record<string, string>> = {};

export const { rendererT, activeLocale, plural } = createPluginI18n(CATALOGS);
